import { render } from "./ClienteDetail.vue?vue&type=template&id=69e97c66&scoped=true"
import script from "./ClienteDetail.vue?vue&type=script&lang=js"
export * from "./ClienteDetail.vue?vue&type=script&lang=js"

import "./ClienteDetail.vue?vue&type=style&index=0&id=69e97c66&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e97c66"]])

export default __exports__